export default "__VITE_PUBLIC_ASSET__b9108f52__"